import { render, staticRenderFns } from "./TenantCommercial.vue?vue&type=template&id=0a946be1&scoped=true"
import script from "./TenantCommercial.vue?vue&type=script&lang=js"
export * from "./TenantCommercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a946be1",
  null
  
)

export default component.exports